
import AppScanDifference from "@/components/stock/ScanDifference.vue";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			show: true
		};
	},
	methods: {
		async cancel() {
			this.$router.go(-1);
		}
	},
	async mounted() {

	},
	components: {
		AppScanDifference
	},

});
